// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const glimmora: PokeData = {
  "id": 970,
  "name": "glimmora",
  "height": 15,
  "weight": 450,
  "base_experience": 184,
  "types": [
    PokeType.ROCK,
    PokeType.POISON
  ],
  "api_moves": [
    "rock-throw",
    "harden",
    "self-destruct",
    "acid-armor",
    "rock-slide",
    "sandstorm",
    "ancient-power",
    "toxic-spikes",
    "rock-polish",
    "power-gem",
    "stealth-rock",
    "venoshock",
    "smack-down",
    "sludge-wave",
    "acid-spray",
    "spiky-shield",
    "mortal-spin"
  ],
  "moves": [
    "rock-throw",
    "rock-slide",
    "sandstorm",
    "ancient-power",
    "toxic-spikes",
    "stealth-rock",
    "acid-rain",
    "poison-jab",
    "poison-powder",
    "venom-drench",
    "boulder_bash",
    "stun-spore",
    "rock-blast"
  ],
  "evolution_chain": {
    "id": 508,
    "item": null,
    "species": [
      {
        "name": "glimmet",
        "order": 966,
        "types": [
          PokeType.ROCK,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "glimmora",
        "order": 967,
        "types": [
          PokeType.ROCK,
          PokeType.POISON
        ],
        "evolves_from_species_id": 969,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 115,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
